// Excludes visually ambiguous characters (0/O, 1/I/L) since codes are also shown as printable text.
const TARGET_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
const TARGET_CODE_LENGTH = 6;

export const generateTargetCode = (): string => {
  let code = '';
  for (let i = 0; i < TARGET_CODE_LENGTH; i++) {
    code += TARGET_CODE_ALPHABET[Math.floor(Math.random() * TARGET_CODE_ALPHABET.length)];
  }
  return code;
};
